// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".exact-link[data-v-74e514d3]{color:#007c86!important}.exact-link-gold[data-v-74e514d3]{color:#bd9400!important}.breddrum[data-v-74e514d3]{position:absolute;bottom:0}.nuxt-link-exact-active span[data-v-74e514d3]{background-color:#007c86!important;color:#fff!important}.bredcumb-size[data-v-74e514d3]{width:70%}@media screen and (max-width:480px){.bredcumb-size[data-v-74e514d3]{width:75%}}", ""]);
// Exports
module.exports = exports;
